<template>
    <!--
        Compact filter chip with current value baked in.
            label · value  v
        When `active`, the chip turns coral-tinted and gets an inline X
        to clear the filter. Clicking the X emits @clear; clicking the
        chip body emits @click for the host to open a popover / sheet.
    -->
    <button
        type="button"
        class="btn btn--sm"
        :style="rootStyle"
        @click="$emit('click')"
    >
        <span :style="labelStyle">{{ label }}</span>
        <span :style="sepStyle">·</span>
        <span :style="valueStyle">{{ value }}</span>
        <Icon name="chevDown" />
        <span
            v-if="active"
            :style="clearDotStyle"
            @click.stop="$emit('clear')"
        >
            <Icon name="x" :size="10" />
        </span>
    </button>
</template>

<script>
import Icon from "./Icon.vue";

export default {
    name: "FacetButton",
    components: { Icon },
    props: {
        label: { type: String, required: true },
        value: { type: String, default: "Any" },
        active: { type: Boolean, default: false },
    },
    computed: {
        rootStyle() {
            return {
                height: "32px",
                gap: "6px",
                padding: "0 10px",
                background: this.active ? "var(--tag-red-soft)" : "var(--surface)",
                borderColor: this.active ? "var(--tag-red-border)" : "var(--border)",
                color: this.active ? "var(--text)" : "var(--text-muted)",
                fontWeight: 450,
            };
        },
        labelStyle() {
            return {
                color: this.active ? "var(--tag-red)" : "var(--text-faint)",
                fontSize: "11.5px",
                fontWeight: 500,
            };
        },
        sepStyle() {
            return { color: "var(--border-strong)" };
        },
        valueStyle() {
            return { color: "var(--text)" };
        },
        clearDotStyle() {
            return {
                marginLeft: "2px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                background: "var(--tag-red)",
                color: "#fff",
                cursor: "pointer",
            };
        },
    },
};
</script>
